export default {
  allElementsExistInArray (arr, target) {
    return target.every(el => arr.includes(el))
  },
  areAllValuesNullEmpty (arr) {
    let ans = true
    arr.forEach(el => { if (el.value !== null && el.value.length > 0) { ans = false } })
    return ans
  },
  randomString () {
    let id = ''
    let alphaNum = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    for (var i = 0; i < 8; i++) { id += alphaNum.charAt(Math.floor(Math.random() * alphaNum.length)) }
    return id
  }
}



// WEBPACK FOOTER //
// ./src/extras/HelperFunctions.js